import {
  Breakpoints,
  styled,
} from '@volkswagen-onehub/components-core';

interface OverlayWrapperProps {
  isOpen: boolean;
}

export const DropdownOverlayWrapper = styled.div<OverlayWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${(props) => (props.isOpen ? '100vh' : 'auto')};

  @media (min-width: ${Breakpoints.b560}px) {
    height: auto;
  }
`;

export const DropdownWrapper = styled.div(
  ({ theme }) => `
  cursor: pointer;
  padding: ${theme.size.dynamic0100} ${theme.size.static300};
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${theme.colors.background.primary};
  border-bottom: 1px solid ${theme.colors.border.default};

  @media (min-width: ${Breakpoints.b960}px) {
      padding: ${theme.size.dynamic0100} ${theme.size.static530};
  }
`
);

export const OverlayWrapper = styled.div<OverlayWrapperProps>(
  ({ theme, isOpen }) => `
  padding: ${theme.size.dynamic0130} 0;
  display: ${isOpen ? 'block' : 'none'};
  overflow-y: scroll;
  background: ${theme.colors.background.primary};
  border-bottom: 1px solid ${theme.colors.border.default};
  flex: 1;
`
);

export const IconWrapper = styled.div`
  margin-left: ${(props) => props.theme.size.dynamic0040};
`;
